<template>
  <el-dialog
    title="学员实名信息"
    :visible.sync="visible"
    width="480px"
    custom-class="MyDialog identity-dialog"
    append-to-body
    :close-on-click-modal="false"
    :before-close="close"
  >
    <el-form
      ref="form"
      v-loading="loading"
      :model="form"
      :rules="rules"
      label-width="90px"
      class="identity-form"
    >
      <el-form-item label="学员姓名">
        <span class="identity-value">{{ realNameStatus === 1 ? detail.realName : detail.studentName }}</span>
      </el-form-item>
      <el-form-item label="学员账号">
        <span class="identity-value">{{ detail.accountUser }}</span>
      </el-form-item>
      <el-form-item v-if="canFillIdCard" label="身份证号" prop="idCard">
        <el-input
          v-model="form.idCard"
          maxlength="18"
          placeholder="请输入学员的身份证号"
          :disabled="saving"
        />
      </el-form-item>
      <el-form-item v-else label="身份证号">
        <span class="identity-value">{{ detail.idCardMasked || '-' }}</span>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button round :disabled="saving" @click="visible = false">关闭</el-button>
      <el-button
        v-if="canFillIdCard"
        type="primary"
        round
        :loading="saving"
        :disabled="loading"
        @click="save"
      >
        确定
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { checkIDCard } from '@/util/util';
import { post } from '@/util/crmAxios';
import { getBasicUrls } from '@/util/config';

const call = (action, data) =>
  post(getBasicUrls().schoolm + '/manage/studentIdentity/' + action, data);

export default {
  data: () => ({
    visible: false,
    loading: false,
    saving: false,
    detail: {},
    form: {
      idCard: ''
    },
    rules: {
      idCard: [
        {
          required: true,
          trigger: 'blur',
          validator: (rule, value, callback) => {
            const idCard = (value || '').trim().toUpperCase();
            if (!idCard) {
              callback(new Error('请输入身份证号'));
            } else if (!checkIDCard(idCard)) {
              callback(new Error('请输入正确的身份证号'));
            } else {
              callback();
            }
          }
        }
      ]
    },
    requestId: ''
  }),
  computed: {
    realNameStatus() {
      return Number(this.detail && this.detail.studentRealNameStatus);
    },
    canFillIdCard() {
      return this.realNameStatus === 0;
    }
  },
  methods: {
    close(done) {
      if (!this.saving) done();
    },
    normalizeIdCard(idCard) {
      return (idCard || '').trim().toUpperCase();
    },
    async open(row) {
      this.visible = true;
      this.loading = true;
      this.detail = {};
      this.form.idCard = '';
      this.requestId =
        'identity_' + Date.now() + '_' + Math.random().toString(36).slice(2);
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.clearValidate();
      });
      try {
        const res = await call('detail', { accountId: row.accountId });
        if (res.code !== 0) throw res;
        this.detail = res.data;
      } catch (e) {
        this.visible = false;
        this.$message.warning(
          this.$getCodeMessage(e.code, e.message, e.messageArgs) ||
            '实名信息读取失败'
        );
      } finally {
        this.loading = false;
      }
    },
    save() {
      if (this.saving) return;
      if (!this.canFillIdCard) {
        this.visible = false;
        return;
      }
      this.$refs.form.validate(async valid => {
        if (!valid) return;
        this.saving = true;
        try {
          const res = await call('authenticate', {
            accountId: this.detail.accountId,
            idCard: this.normalizeIdCard(this.form.idCard),
            requestId: this.requestId
          });
          if (res.code !== 0) throw res;
          this.visible = false;
          this.$message.success('实名认证成功');
          this.$emit('success');
        } catch (e) {
          this.$message.warning(
            this.$getCodeMessage(e.code, e.message, e.messageArgs) ||
              '认证失败，请稍后重试'
          );
        } finally {
          this.saving = false;
        }
      });
    }
  }
};
</script>

<style lang="scss">
.identity-dialog {
  border-radius: 20px;

  .el-dialog__header {
    background: rgb(74, 131, 232);
    border-radius: 20px 20px 0 0;

    .el-dialog__title,
    .el-dialog__close {
      color: white;
    }
  }

  .el-dialog__body {
    padding: 24px 32px 8px;
  }

  .dialog-footer button {
    border-radius: 20px;
  }

  .identity-form .identity-value {
    color: #303133;
    font-weight: 500;
  }
}
</style>
